<div class="mt-5 mb-5 admin-event-container">
    <div class="row ml-2 mb-5 mr-5">
        <div class="col-6">
            <button type="button" class="btn btn-primary" (click)="createNewEvent()">
                Create New Event
            </button>
        </div>
        <div class="col-6 d-flex justify-content-end">
            <button type="button" class="btn btn-primary" (click)="importEvents()">
                Import Events
            </button>
        </div>
    </div>

    <div class="row ms-4 mb-5 me-5 mt-4">
        <div class="mb-3">
            <button type="button" class="btn btn-primary" (click)="refreshGrid()">
                <fa-icon [icon]="faRetweet"></fa-icon>
            </button>
        </div>
        <div class="content mb-5" style="width: 100%; height: 85vh;">
            <ag-grid-angular style="width: 100%; height: 85vh;"
                             class="ag-theme-quartz"
                             [rowData]="rowData"
                             [columnDefs]="columnDefs"
                             (rowClicked)="rowClicked($event)"
                             (gridReady)="onGridReady($event)"
                             [gridOptions]="gridOptions"
                             pagination="true">
            </ag-grid-angular>
        </div>
    </div>
</div>
